import React, { useState, useEffect, useCallback } from "react";
import "./LiveVod.scss";
import DynamicHeader from "components/GlobalComponents/DynamicHeader/DynamicHeader";
import LoadingComp from "components/GlobalComponents/LoadingComp/LoadingComp";
import DynamicButton from "components/GlobalComponents/DynamicButton/DynamicButton";
import { useTranslation } from "react-i18next";
import LiveStreamComp from "./LiveStreamComp";
import { fetchChannelVideos, checkChannelLive } from "../../API/youtube";

export default function LiveVod() {
  const [videos, setVideos] = useState([]);
  const [liveVideos, setLiveVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const [t] = useTranslation();

  // Fetch live videos separately so they always appear at top
  useEffect(() => {
    checkChannelLive()
      .then(({ isLive, liveVideos: live }) => {
        if (isLive && live.length > 0) {
          setLiveVideos(live);
        }
      })
      .catch((err) => console.error("Failed to check live status:", err));
  }, []);

  const loadVideos = useCallback(async (pageToken) => {
    try {
      const { videos: newVideos, nextPageToken: token } =
        await fetchChannelVideos({
          pageToken,
          maxResults: 6,
        });
      setVideos((prev) => [...prev, ...newVideos]);
      setNextPageToken(token);
    } catch (err) {
      console.error("Failed to fetch YouTube videos:", err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, []);

  useEffect(() => {
    loadVideos();
  }, [loadVideos]);

  const handleLoadMore = () => {
    if (nextPageToken) {
      setLoadingMore(true);
      loadVideos(nextPageToken);
    }
  };

  // IDs of live videos so we don't duplicate them in the VOD list
  const liveIds = new Set(liveVideos.map((v) => v.id));

  return (
    <div className="live-vod-vertical">
      <DynamicHeader title={"Live & VOD"} />
      <div className="live-vod-wrapper">
        {loading ? (
          <div className="loading-space">
            <LoadingComp loading={true} />
          </div>
        ) : (
          <>
            {/* Live videos pinned at the top */}
            {liveVideos.map((video) => (
              <LiveStreamComp
                key={video.id}
                videoId={video.id}
                title={video.title}
                isLive={true}
              />
            ))}
            {/* VOD videos (exclude any that are already shown as live) */}
            {videos
              .filter((video) => !liveIds.has(video.id))
              .map((video) => (
                <LiveStreamComp
                  key={video.id}
                  videoId={video.id}
                  title={video.title}
                  isLive={video.isLive}
                />
              ))}
          </>
        )}
      </div>
      {nextPageToken && (
        <DynamicButton
          text={loadingMore ? "..." : t("navigation.more")}
          action={handleLoadMore}
          type="secondary"
        />
      )}
    </div>
  );
}
